// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DEV-ONLY: global design overlay (URL ?overlay=image.png) */
/* Overlay is portaled into #design-overlay-root so it scrolls with page content. */

.design-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: visible;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 9998;
  padding: 0 0 40px 0;
  pointer-events: none;
}

.design-overlay__image {
  display: block;
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  object-fit: none;
  vertical-align: top;
  flex-shrink: 0;
}

.design-overlay__image--difference {
  mix-blend-mode: difference;
}

.design-overlay__panel {
  width: 280px;
  color: #e0ddd8;
  font-size: 11px;
  font-family: system-ui, sans-serif;
}

.design-overlay__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.design-overlay__row span:first-of-type {
  flex: 0 0 72px;
  color: #c9c5bf;
}

.design-overlay__row input[type="checkbox"] {
  margin: 0;
}

.design-overlay__row input[type="range"] {
  flex: 1 1;
  min-width: 0;
}

.design-overlay__input-num {
  width: 56px;
  padding: 2px 6px;
  font-size: 11px;
  background: #3a3632;
  border: 1px solid #4a4541;
  border-radius: 4px;
  color: #e0ddd8;
}

.design-overlay__select {
  flex: 1 1;
  min-width: 0;
  padding: 2px 6px;
  font-size: 11px;
  background: #3a3632;
  border: 1px solid #4a4541;
  border-radius: 4px;
  color: #e0ddd8;
}

.design-overlay__value {
  flex: 0 0 32px;
  font-variant-numeric: tabular-nums;
}

.design-overlay__panel-label {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #8eb9b2;
  margin: 10px 0 4px 0;
}

.design-overlay__unit {
  flex: 0 0 18px;
  font-size: 10px;
  color: #c9c5bf;
}

.design-overlay__reset {
  margin-top: 8px;
  width: 100%;
  padding: 6px 10px;
  font-size: 11px;
  cursor: pointer;
  background: #4a4541;
  color: #e0ddd8;
  border: 1px solid #5a5551;
  border-radius: 4px;
}

.design-overlay__reset:hover {
  background: #5a5551;
}
`, "",{"version":3,"sources":["webpack://./src/components/devtools/DesignOverlay.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D,mFAAmF;;AAEnF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* DEV-ONLY: global design overlay (URL ?overlay=image.png) */\n/* Overlay is portaled into #design-overlay-root so it scrolls with page content. */\n\n.design-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: visible;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  z-index: 9998;\n  padding: 0 0 40px 0;\n  pointer-events: none;\n}\n\n.design-overlay__image {\n  display: block;\n  width: auto;\n  height: auto;\n  max-width: none;\n  max-height: none;\n  object-fit: none;\n  vertical-align: top;\n  flex-shrink: 0;\n}\n\n.design-overlay__image--difference {\n  mix-blend-mode: difference;\n}\n\n.design-overlay__panel {\n  width: 280px;\n  color: #e0ddd8;\n  font-size: 11px;\n  font-family: system-ui, sans-serif;\n}\n\n.design-overlay__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.design-overlay__row span:first-of-type {\n  flex: 0 0 72px;\n  color: #c9c5bf;\n}\n\n.design-overlay__row input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.design-overlay__row input[type=\"range\"] {\n  flex: 1;\n  min-width: 0;\n}\n\n.design-overlay__input-num {\n  width: 56px;\n  padding: 2px 6px;\n  font-size: 11px;\n  background: #3a3632;\n  border: 1px solid #4a4541;\n  border-radius: 4px;\n  color: #e0ddd8;\n}\n\n.design-overlay__select {\n  flex: 1;\n  min-width: 0;\n  padding: 2px 6px;\n  font-size: 11px;\n  background: #3a3632;\n  border: 1px solid #4a4541;\n  border-radius: 4px;\n  color: #e0ddd8;\n}\n\n.design-overlay__value {\n  flex: 0 0 32px;\n  font-variant-numeric: tabular-nums;\n}\n\n.design-overlay__panel-label {\n  font-weight: 700;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #8eb9b2;\n  margin: 10px 0 4px 0;\n}\n\n.design-overlay__unit {\n  flex: 0 0 18px;\n  font-size: 10px;\n  color: #c9c5bf;\n}\n\n.design-overlay__reset {\n  margin-top: 8px;\n  width: 100%;\n  padding: 6px 10px;\n  font-size: 11px;\n  cursor: pointer;\n  background: #4a4541;\n  color: #e0ddd8;\n  border: 1px solid #5a5551;\n  border-radius: 4px;\n}\n\n.design-overlay__reset:hover {\n  background: #5a5551;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
